export default "__VITE_ASSET__ab9593b2__"